import React, { useState, useEffect } from 'react';
import RequestAQuoteForm from '../../../components/commons/forms/request-a-quote/request-a-quote.component';
import heroImageSrc from '../../../images/consulting-ehs/ehs-primary-background.png';
import Hero from '../../../components/commons/hero/hero.component';
import { getRequestQuotePageData } from '../../../js/api/specialty-pages/_request-a-quote.data';
import Loader from '../../../components/commons/helpers/loader/loader.component';

// RP #Task 56 - Request a Quote
function RequestAQuotePage({ page: { modules } }) {
  const [responseMainContent, setResponseMainContent] = useState({});
  const [responseDropDownContent, setResponseDropDownContent] = useState({});
  const [status, setStatus] = useState(null);
  const [noContent] = useState(204);

  useEffect(() => {
    const fetchData = async () => {
      const getResponse = await getRequestQuotePageData();

      if (getResponse) {
        setStatus(getResponse.status);
        setResponseMainContent(getResponse.MainContent);
        setResponseDropDownContent(getResponse.DropDownContent);
      }
    };
    fetchData();
  }, []);

  if (
    status == noContent ||
    (responseMainContent &&
      responseDropDownContent &&
      responseDropDownContent.Country != undefined)
  ) {
    return (
      <div className="remote-modeling-container">
        <Hero
          src={
            status != noContent && responseMainContent.HeaderImage_src
              ? responseMainContent.HeaderImage_src
              : ''
          }
          mobileImgSrc={
            status != noContent && responseMainContent.MobileImage_src
              ? responseMainContent.MobileImage_src
              : ''
          }
          alt={
            status != noContent && responseMainContent.HeaderImage_alt
              ? responseMainContent.HeaderImage_alt
              : ''
          }
          title={
            status != noContent && responseMainContent.Title
              ? responseMainContent.Title
              : 'Please contact admin for page content'
          }
          template="standard"
          colorCategory="policies"
        />
        <div className="trinity-container">
          <RequestAQuoteForm data={responseDropDownContent} status={status} />
        </div>
      </div>
    );
  }
  return <Loader />;
}

export default RequestAQuotePage;
